<template>
  <div class="ma-6">
    <div class="page-header-left">
      <h2 class="pr-3">MutasiBank</h2>
    </div>
    <div class="mt-4 pr-0 pl-0 pt-2" style="border: thin solid rgba(0,0,0,.12)">    <v-toolbar elevation="0">
      <v-text-field
          flat
          solo
          clearable
          prepend-icon="search"
          placeholder="Type something"
          v-model="opsitabletrx.search"
          hide-details
          class=""
      ></v-text-field>
      <v-spacer></v-spacer>
      <div class="mt-6">
        <v-select
            label="Bank"
            item-text="label"
            item-value="code"
            v-model="opsitabletrx.bankcode"
            :items="bankcodes"
        ></v-select>
      </div>
<!--      <div class="mt-6">-->
<!--        <v-select-->
<!--            clearable-->
<!--            label="Status"-->
<!--            item-text="label"-->
<!--            item-value="id"-->
<!--            v-model="opsitabletrx.statustrx"-->
<!--            :items="trxstatuses"-->
<!--        ></v-select>-->
<!--      </div>-->
      <div class="mt-6">
        <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="opsitabletrx.awal"
                label="Tanggal Awal"
                prepend-icon="event"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="opsitabletrx.awal" @input="menu1 = false"></v-date-picker>
        </v-menu>
      </div>
      <div class="mt-6">
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="opsitabletrx.akhir"
                label="Tanggal Akhir"
                prepend-icon="event"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="opsitabletrx.akhir" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </div>
      <v-btn small elevation="0" class="ml-2" color="primary" @click.native="getMutasiBank(opsitabletrx)">
        <v-icon dark>refresh</v-icon>Refresh
      </v-btn>
    </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
          dense

          sort-by="id"
          :sort-desc="sortdes"
          :headers="headers"
          :search="search"
          :items="mutasibank"
          class="elevation-0"
          item-key="id"
          :options.sync="opsitabletrx"
          :server-items-length="totalmutasibank"
          :loading="loading"
          @update:options="getMutasiBank(opsitabletrx)">
        <template v-slot:item.mutasi="{ item }">
          <div  class="text-right">
            {{formatAngka(item.mutasi)}}
          </div>
        </template>
        <template v-slot:item.createat="{ item }">
          {{formatDate(item.createat)}}
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Utils from '@/plugins/utils'
import S from 'string'
import moment from 'moment'

export default {
  name: 'MutasiBanks',
  data: () => ({
    search: '',
    tab: '',
    autorefresh: false,
    intervaltrxautorefresh: '',
    menu1: false,
    menu2: false,
    sortdes: [true],
    dateawal: moment().add(7, 'hours').toISOString().substr(0, 10),
    dateakhir: moment().add(7, 'hours').toISOString().substr(0, 10),
    opsitabletrx: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      statustrx: '',
      sellerid: '',
      sortBy: ['id'],
      bankcode: '04',
      awal: moment().add(7, 'hours').toISOString().substr(0, 10),
      akhir: moment().add(7, 'hours').toISOString().substr(0, 10)
    },
    bankcodes: [
      {
        code: '04',
        label: 'BRI'
      },
      {
        code: '05',
        label: 'MANDIRI'
      }
    ],
    trxstatuses: [
      {
        id: 0,
        label: 'Pending'
      },
      {
        id: 1,
        label: 'Sukses'
      }
    ],
    headers: [
      {
        text: 'TrxId',
        value: 'id',
        width: 100
      },
      {
        text: 'Waktu',
        value: 'createat',
        width: 200
      },
      {
        text: 'Waktu Trx',
        value: 'tanggaltran',
        width: 200
      },
      {
        text: 'Keterangan',
        value: 'keterangan'
      },
      {
        text: 'Mutasi',
        value: 'mutasi',
        align: 'right',
        width: 300
      },
      {
        text: 'Reff',
        value: 'reff',
        width: 200
      }
    ]
  }),
  computed: {
    ...mapState('AdminBankStore', ['loading', 'mutasibank', 'totalmutasibank'])
  },
  methods: {
    ...mapActions('AdminBankStore', ['getMutasiBank']),
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    potongnama (val) {
      if (val.length > 20) {
        return S(val).left(20).replaceAll('`', '').s
      } else {
        return val.toUpperCase()
      }
    },
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    }
  }
}
</script>

<style scoped>

</style>
